import styled from 'styled-components';
import { getCookie } from '../util/cookieUtil';
import { COOKIE_NAME } from '../Config';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunityList } from '../community/slices/communityListSlice';

const Footer = () => {
  const dispatch = useDispatch();
  const titleList = useSelector((state) => state.communityList.titleList);

  useEffect(() => {
    dispatch(fetchCommunityList());
  }, [dispatch]);

  const [footerRole, setFooterRole] = useState();

  const getMemberInfo = getCookie(COOKIE_NAME);

  useEffect(() => {
    setFooterRole(getMemberInfo?.roleNames[0]);
  }, []);

  const loginOnHandler = (event) => {
    // if (!isCookieChecked()) {
    //   event.preventDefault();
    //   // 로그인하지 않은 상태라면 로그인 페이지로 이동
    //   // window.location.href = '/member/login';
    //   return;
    // }
  };
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterMenu>
          <FooterColumn>
            <h4>연수원 소개</h4>
            <ul>
              <li>
                <a href="https://keif.kr/">인사말</a>
              </li>
              <li>
                <a href="https://keif.kr/">KEIF 소개/비전</a>
              </li>
              <li>
                <a href="https://keif.kr/">관련 규정 (보수/위생 교육)</a>
              </li>
              <li>
                <a href="https://keif.kr/">CI</a>
              </li>
            </ul>
          </FooterColumn>
          <FooterColumn>
            <h4>교육 사업 소개</h4>
            <ul>
              <li>
                <a href="https://keif.kr/fitness.html">보디빌딩 보수 교육</a>
              </li>
              <li>
                <a href="https://keif.kr/pilates.html">필라테스 보수 교육</a>
              </li>
              <li>
                <a href="https://keif.kr/zent.html">젠티 마스터 교육</a>
              </li>
              <li>
                <a href="https://keif.kr/edu.html">스포츠 시설 위생 교육</a>
              </li>
            </ul>
          </FooterColumn>
          <FooterColumn>
            <h4>교육 신청</h4>
            <ul>
              <li>
                <StyledLink to="/curriculum/scheduleAndApply" onClick={loginOnHandler}>
                  교육 일정 및 신청
                </StyledLink>
              </li>
              <li>
                <StyledLink to="/curriculum/guide">교육 신청 가이드</StyledLink>
              </li>
            </ul>
          </FooterColumn>
          <FooterColumn>
            <h4>인스트럭터</h4>
            <ul>
              <li>
                <StyledLink to="/memberSearch/search" onClick={loginOnHandler}>
                  인스트럭터
                </StyledLink>
              </li>
            </ul>
          </FooterColumn>
          <FooterColumn>
            <h4>증명서 발급</h4>
            <ul>
              <li>
                <StyledLink to="/mypage">증명서 발급</StyledLink>
              </li>
            </ul>
          </FooterColumn>
          {titleList.length > 0 && (
            <FooterColumn>
              <h4>커뮤니티</h4>
              <ul>
                {titleList.map((item, index) => (
                  <li key={index}>
                    <StyledLink to={`/community/${item.id}`}>{item.title}</StyledLink>
                  </li>
                ))}
              </ul>
            </FooterColumn>
          )}
          <FooterColumn>
            <h4>고객센터</h4>
            <ul>
              <li>전화: 031-951-3878</li>
              <li>이메일: officialsss7777@gmail.com</li>
              <li>
                {footerRole === 'ADMIN' ? (
                  <>
                    <StyledLink to="/admin/member">관리자 페이지</StyledLink>
                    {/* <UpdateButton onClick={handleUpdateMemberNumbers}>Update Member Numbers</UpdateButton> */}
                  </>
                ) : (
                  <></>
                )}
              </li>
              <StyledLink to="/member/logout">로그아웃</StyledLink>
            </ul>
          </FooterColumn>
        </FooterMenu>
      </FooterWrapper>
      <FooterInfo>
        <h3>사단법인 한국피트니스교육연수원</h3>
        <p>사업자 등록번호: 681-80-02906 대표: 김준수</p>
        <p>13135 경기도 성남시 수정구 산성대로 553, 박애관동 506호 1호 (양지동 212)</p>
        <a href="https://keif.kr/terms/v2/broj_privacy.html">개인정보 처리방침</a>
      </FooterInfo>
    </FooterContainer>
  );
};

const UpdateButton = styled.button`
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #45a049;
  }
`;

const FooterContainer = styled.footer`
  margin-top: 170px;
  background-color: #f5f5f5;
  padding: 100px 0;
  width: 100%;

  @media (min-height: 1500px) {
    margin-top: 160px;
    padding: 300px 0;
  }

  @media (max-width: 480px) {
    margin-top: 20px;
    padding: 20px 0;
  }
`;

const FooterWrapper = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1; /* 컨텐츠가 부족할 때, footer가 아래로 채워지도록 설정 */
  @media (min-height: 1500px) {
    margin-bottom: 100px;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

const FooterMenu = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const FooterColumn = styled.div`
  flex: 1;
  text-align: left;

  h4 {
    font-weight: 600;
    margin-bottom: 30px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 15px;
    color: #808080;

    a {
      color: #808080;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media (max-width: 768px) {
    text-align: center;
    margin-bottom: 20px;

    li {
      margin-bottom: 8px;
    }
  }
`;

const FooterInfo = styled.div`
  max-width: 1920px;
  margin-top: 30px;
  text-align: justify;
  margin: 30px auto;
  padding: 0 20px;
  gap: 30px;

  p {
    margin: 10px 0;
    color: #808080;
  }

  a {
    color: #414141;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }

  @media (max-height: 2300px) {
    p {
      margin: 20px 0;
    }
    a {
      margin: 20px 0;
    }
  }
`;

const StyledLink = styled(Link)`
  color: #808080;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export default Footer;
